import Cookies from 'js-cookie';

const INTERCOM_VISITED_COOKIE = 'intercom_visited';
const COOKIE_EXPIRY_DAYS = 30;

/**
 * Checks if user is a new visitor and automatically opens Intercom widget
 * on homepage or product pages
 */
const handleIntercomAutoOpen = () => {
  // Check if this is a new visitor (no cookie set)
  const hasVisited = Cookies.get(INTERCOM_VISITED_COOKIE);

  if (hasVisited) {
    return; // User has visited before, don't auto-open
  }

  // Don't auto-open on mobile — Intercom covers the entire page
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  // Get current pathname
  const currentPath = window.location.pathname;

  // Check if user is on homepage or product pages
  const isHomepage = currentPath === '/';
  const isProductPage = currentPath.startsWith('/product');

  // Only auto-open on homepage or product pages for non-mobile visitors
  if (!isMobile && (isHomepage || isProductPage)) {
    // Wait for Intercom to be available
    const checkIntercom = setInterval(() => {
      if (window.Intercom) {
        clearInterval(checkIntercom);

        // Open the Intercom messenger
        window.Intercom('show');

        // Set cookie to mark visitor as having visited
        Cookies.set(INTERCOM_VISITED_COOKIE, 'true', {
          expires: COOKIE_EXPIRY_DAYS,
          path: '/',
        });
      }
    }, 100); // Check every 100ms

    // Safety timeout to stop checking after 10 seconds
    setTimeout(() => {
      clearInterval(checkIntercom);
    }, 10000);
  } else {
    // User is on a different page, just set the cookie
    // so we know they've visited but don't auto-open
    Cookies.set(INTERCOM_VISITED_COOKIE, 'true', {
      expires: COOKIE_EXPIRY_DAYS,
      path: '/',
    });
  }
};

export default handleIntercomAutoOpen;
